import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+10.000',
    label: 'Insegnanti'
  }, {
    value: '1.200+',
    label: 'Lezioni pronte'
  }, {
    value: '380+',
    label: 'Recensioni'
  }, {
    value: '94%',
    label: 'Di soddisfazione'
  }];
  return <section className="py-8 border-y border-brand-creamDark bg-white/50" data-id="element-151">
      <div className="max-w-5xl mx-auto px-4" data-id="element-152">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-brand-creamDark/0 md:divide-brand-creamDark" data-id="element-153">
          {stats.map((stat, i) => <div key={i} className="flex flex-col items-center justify-center" data-id="element-154">
              <span className="text-3xl md:text-4xl font-serif font-bold text-brand-text mb-1" data-id="element-155">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-brand-gray uppercase tracking-wider font-medium" data-id="element-156">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}